import { useMutation, useQuery } from 'react-query';

import { quoteVersionService } from 'quotes/services';
import { IQuoteVersionRequestPayload } from 'quotes/types';

export const useGetQuoteVersionData = (
  requestPayload: IQuoteVersionRequestPayload,
  options: { enabled?: boolean } = {}
) => {
  const { data, isLoading } = useQuery(
    ['quoteVersionData', requestPayload],
    ({ signal }) => quoteVersionService.getQuoteVersionData(requestPayload, signal),
    options
  );

  return {
    quoteVersionData: data?.record ?? null,
    isLoading,
  };
};

export const useQuoteVersionActions = () => ({
  ...useInitializeDraftVersion(),
  ...useResetDraftVersion(),
  ...useReleaseDraftVersion(),
});

const useInitializeDraftVersion = () => {
  const { mutateAsync } = useMutation(quoteVersionService.initializeDraftVersion);

  const initializeDraftVersion = (data) => mutateAsync(data);

  return { initializeDraftVersion };
};

const useResetDraftVersion = () => {
  const { mutateAsync } = useMutation(quoteVersionService.resetDraftVersion);

  const resetDraftVersion = (data) => mutateAsync(data);

  return { resetDraftVersion };
};

const useReleaseDraftVersion = () => {
  const { mutateAsync } = useMutation(quoteVersionService.releaseDraftVersion);

  const releaseDraftVersion = (data) => mutateAsync(data);

  return { releaseDraftVersion };
};
